import { getFallbackSource } from '../Common/CommonComponents/ImageFallback';

export const formatBrand = (brand) => {
  let hostName = window.location.hostname && window.location.hostname.split('.').pop();
  if (!hostName || hostName === 'localhost') {
    hostName = 'com';
  }
  return `${brand}.${hostName}`;
};

export default class BrandLogoHelper {
  static GetBrand = (defaultBrand, retrievedBrand) => {
    if (!!retrievedBrand && typeof retrievedBrand === 'string') {
      return retrievedBrand;
    }
    return defaultBrand;
  }

  static GetLogo = (defaultLogo, retrievedLogo, logoWebp) => {
    if (retrievedLogo) {
      return `https://dq3ll41r32qbq.cloudfront.net${getFallbackSource(logoWebp || retrievedLogo, retrievedLogo)}`;
    }
    return defaultLogo;
  }

  static GetLogoClass = (defaultLogo, retrievedLogo, className) => {
    const img = document.getElementsByClassName(className)[0];
    if (img && !(img.className.indexOf('square-logo') >= 0)) {
      const { height, width } = img;
      if (height && width) {
        if (height / width > 0.4) {
          img.className = `${img.className} square-logo`;
        }
      }
    }
  }
}
